(function () {
  var rulesCache = null;
  var rulesPromise = null;

  function parseJson(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return fallback;
    }
  }

  function savedLocation(root) {
    var fromCart = null;
    if (window.MHDeliveryLocation) {
      fromCart = window.MHDeliveryLocation.normalise(root && root.getAttribute('data-saved-destination'));
      var fromStore = window.MHDeliveryLocation.read();
      if (fromStore) return fromStore;
    }
    return fromCart;
  }

  function saveLocation(root, postcode, suburb, province, deliveryDate) {
    var fields = {
      postcode: postcode,
      suburb: suburb,
      state: province,
      province: province
    };
    if (deliveryDate) fields.delivery_date = deliveryDate;
    if (window.MHDeliveryLocation) window.MHDeliveryLocation.write(fields);

    // PDP estimate-only mode: keep localStorage for UX, do not write cart attributes
    // (avoids Christmas checkout conflicts with dest_address).
    if (root && root.getAttribute('data-pdp-estimate') === 'true') return;
    

    var routes = window.routes || {};
    if (!routes.cart_update_url) return;
    var existing = {};
    try {
      existing = JSON.parse((root && root.getAttribute('data-saved-destination')) || '{}') || {};
    } catch (error) {
      existing = {};
    }
    if (!existing || typeof existing !== 'object') existing = {};
    var oldPostcode = String(existing.postcode || '').replace(/\D/g, '');
    var postcodeChanged = !!(oldPostcode && parseInt(oldPostcode, 10) !== parseInt(postcode, 10));
    var merged = Object.assign({}, existing, {
      postcode: postcode,
      suburb: suburb || (postcodeChanged ? '' : existing.suburb) || '',
      state: province || (postcodeChanged ? '' : existing.state) || ''
    });
    if (postcodeChanged) {
      merged.address1 = '';
      merged.address2 = '';
    }
    if (!existing.delivery_date && deliveryDate) merged.delivery_date = deliveryDate;
    var json = JSON.stringify(merged);
    if (root) root.setAttribute('data-saved-destination', json);
    fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { dest_address: json } })
    }).catch(function () {});
  }

  function uniquePlaces(places) {
    var seen = {};
    return places.filter(function (place) {
      var key = (place.suburb || '').toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function fetchSuburbs(countryCode, postcode) {
    var code = (countryCode || 'AU').toUpperCase();
    var zip = String(postcode || '').replace(/\D/g, '');
    if (code === 'AU' && zip.length === 3) {
      var n = parseInt(zip, 10);
      if (n >= 800 && n <= 999) zip = '0' + zip;
    }
    return fetch('https://api.zippopotam.us/' + encodeURIComponent(code) + '/' + encodeURIComponent(zip))
      .then(function (response) {
        if (!response.ok) return [];
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.places) return [];
        return uniquePlaces(data.places.map(function (place) {
          return {
            suburb: place['place name'],
            province: place['state abbreviation'] || place.state || ''
          };
        }));
      });
  }

  function parsePostcode(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length < 3 || digits.length > 4) return null;
    return parseInt(digits, 10);
  }

  function normaliseAuPostcode(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 4);
    if (digits.length === 3) {
      var n = parseInt(digits, 10);
      if (n >= 800 && n <= 999) return '0' + digits;
    }
    return digits;
  }

  function loadRules(url) {
    if (rulesCache) return Promise.resolve(rulesCache);
    if (rulesPromise) return rulesPromise;
    if (!url) return Promise.resolve(null);
    rulesPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (data) {
        rulesCache = data;
        return data;
      })
      .catch(function () {
        rulesPromise = null;
        return null;
      });
    return rulesPromise;
  }

  function hasShippingZone(rules, postcode) {
    if (!rules || !rules.rules) return true;
    var code = parsePostcode(postcode);
    if (code == null) return false;
    for (var i = 0; i < rules.rules.length; i++) {
      var start = parseInt(rules.rules[i].postcode_start, 10);
      var end = parseInt(rules.rules[i].postcode_end, 10);
      if (code >= start && code <= end) return true;
    }
    return false;
  }

  function formatEta(date) {
    var D = window.MHDeliveryDate;
    if (D) return D.formatLong(date);
    return '';
  }

  function earliestDate(province, countryCode, root) {
    var D = window.MHDeliveryDate;
    if (!D) return null;
    var engine = D.createEngine({
      minLeadDays: root.getAttribute('data-min-lead-days'),
      cutoffHour: root.getAttribute('data-cutoff-hour'),
      timezone: root.getAttribute('data-timezone'),
      shippingCountry: countryCode,
      deliveryState: province,
      allowedWeekdays: root.getAttribute('data-allowed-weekdays'),
      minDate: root.getAttribute('data-min-date')
    });
    return engine.computeFirstEligible();
  }

  function init(root) {
    var countryCode = (root.getAttribute('data-country-code') || 'AU').toUpperCase();
    if (countryCode.length !== 2) countryCode = 'AU';
    var rulesUrl = root.getAttribute('data-shipping-rules-url') || '';
    var stringsEl = root.querySelector('[data-delivery-strings]');
    var strings = stringsEl ? parseJson(stringsEl.textContent, {}) : {};
    var form = root.querySelector('[data-delivery-form]');
    var summaryEl = root.querySelector('[data-delivery-summary]');
    var summaryPlaceEl = root.querySelector('[data-summary-place]');
    var summaryDateEl = root.querySelector('[data-summary-date]');
    var changeBtn = root.querySelector('[data-delivery-change]');
    var checkBtn = root.querySelector('[data-delivery-check]');
    var postcodeInput = root.querySelector('[data-postcode-input]');
    var suburbSelect = root.querySelector('[data-suburb-input]');
    var errorEl = root.querySelector('[data-delivery-error]');
    var resultEl = root.querySelector('[data-delivery-result]');
    var noteEl = root.querySelector('[data-delivery-note]');
    var dateEl = root.querySelector('[data-delivery-date]');
    var lookupTimer = null;
    var lookupToken = 0;
    var places = [];

    if (!form || !checkBtn || !postcodeInput || !suburbSelect) return;
    if (root.dataset.deliveryReady === 'true') return;
    root.dataset.deliveryReady = 'true';

    function resetSuburb(placeholder) {
      places = [];
      suburbSelect.innerHTML = '';
      var option = document.createElement('option');
      option.value = '';
      option.textContent = placeholder || strings.selectSuburb || 'Select suburb';
      suburbSelect.appendChild(option);
      suburbSelect.value = '';
      suburbSelect.disabled = true;
      suburbSelect.classList.remove('filled');
    }

    function hideEstimate() {
      if (resultEl) resultEl.setAttribute('hidden', '');
      if (noteEl) noteEl.setAttribute('hidden', '');
    }

    function markReady() {
      requestAnimationFrame(function () {
        root.classList.add('is-ready');
      });
    }

    function showForm() {
      root.classList.remove('is-summary');
      root.classList.remove('has-eta');
      root.classList.add('is-editing');
      if (summaryEl) {
        summaryEl.removeAttribute('hidden');
        summaryEl.setAttribute('aria-hidden', 'true');
      }
      if (form) {
        form.removeAttribute('hidden');
        form.setAttribute('aria-hidden', 'false');
      }
      placeDelivery();
      markReady();
    }

    function showSummary(suburb, postcode, eta) {
      if (summaryPlaceEl) summaryPlaceEl.textContent = (suburb + ' ' + postcode).trim();
      if (summaryDateEl) summaryDateEl.textContent = eta;
      if (summaryEl) {
        summaryEl.removeAttribute('hidden');
        summaryEl.setAttribute('aria-hidden', 'false');
      }
      root.classList.add('is-summary');
      root.classList.add('has-eta');
      root.classList.remove('is-editing');
      if (form) {
        form.removeAttribute('hidden');
        form.setAttribute('aria-hidden', 'true');
      }
      placeDelivery();
      markReady();
    }

    function placeDelivery() {
      var slot = document.querySelector('[data-hamper-atc-delivery]');
      if (slot && root.parentElement !== slot) slot.appendChild(root);
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.setAttribute('hidden', '');
    }

    function showError(message) {
      hideEstimate();
      showForm();
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.removeAttribute('hidden');
      } else {
        clearError();
      }
    }

    function showEstimate(suburb, postcode, eta) {
      clearError();
      if (dateEl) dateEl.textContent = eta;
      if (resultEl) resultEl.removeAttribute('hidden');
      if (noteEl) noteEl.removeAttribute('hidden');
      showSummary(suburb, postcode, eta);
    }

    function setChecking(isChecking) {
      checkBtn.disabled = isChecking;
      checkBtn.textContent = isChecking ? (strings.checking || 'Checking…') : (strings.check || 'Check');
    }

    function populateSuburbs(nextPlaces, selectedSuburb) {
      places = nextPlaces;
      suburbSelect.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = strings.selectSuburb || 'Select suburb';
      suburbSelect.appendChild(placeholder);

      places.forEach(function (place) {
        var option = document.createElement('option');
        option.value = place.suburb;
        option.textContent = place.suburb;
        option.setAttribute('data-province', place.province || '');
        suburbSelect.appendChild(option);
      });

      suburbSelect.disabled = places.length === 0;

      if (selectedSuburb) {
        var match = places.filter(function (place) {
          return place.suburb.toLowerCase() === String(selectedSuburb).toLowerCase();
        })[0];
        if (match) suburbSelect.value = match.suburb;
      }

      if (!suburbSelect.value && places.length === 1) {
        suburbSelect.value = places[0].suburb;
      }

      suburbSelect.classList.toggle('filled', Boolean(suburbSelect.value));
    }

    function lookupPostcode() {
      var postcode = normaliseAuPostcode(postcodeInput.value);
      postcodeInput.value = postcode;
      postcodeInput.classList.toggle('filled', postcode.length > 0);
      hideEstimate();
      clearError();

      if (postcode.length !== 4) {
        resetSuburb();
        return Promise.resolve([]);
      }

      var token = ++lookupToken;
      suburbSelect.disabled = true;

      return fetchSuburbs(countryCode, postcode).then(function (nextPlaces) {
        if (token !== lookupToken) return [];
        if (!nextPlaces.length && countryCode !== 'AU') {
          return fetchSuburbs('AU', postcode);
        }
        return nextPlaces;
      }).then(function (nextPlaces) {
        if (token !== lookupToken) return [];
        if (!nextPlaces.length) {
          resetSuburb();
          showError(strings.invalidPostcode || 'Enter a valid postcode.');
          return [];
        }
        populateSuburbs(nextPlaces);
        clearError();
        return nextPlaces;
      }).catch(function () {
        if (token !== lookupToken) return [];
        resetSuburb();
        showError(strings.checkError || "We couldn't check delivery for this postcode. Try again.");
        return [];
      });
    }

    function selectedPlace() {
      var suburb = suburbSelect.value;
      var match = places.filter(function (place) { return place.suburb === suburb; })[0];
      var option = suburbSelect.options[suburbSelect.selectedIndex];
      return {
        suburb: suburb,
        province: (match && match.province) || (option && option.getAttribute('data-province')) || ''
      };
    }

    function applyEstimate() {
      var postcode = normaliseAuPostcode(postcodeInput.value);
      postcodeInput.value = postcode;
      var place = selectedPlace();

      if (postcode.length !== 4) {
        showError(strings.invalidPostcode || 'Enter a valid postcode.');
        return;
      }
      if (!place.suburb) {
        showError(strings.selectSuburbError || 'Select a suburb for this postcode.');
        return;
      }

      setChecking(true);
      clearError();

      loadRules(rulesUrl)
        .then(function (rules) {
          if (rules && !hasShippingZone(rules, postcode)) {
            showError(strings.noShipping || "Sorry, we don't deliver to this postcode.");
            return;
          }

          var first = earliestDate(place.province, countryCode, root);
          if (!first) {
            showError(strings.checkError || "We couldn't check delivery for this postcode. Try again.");
            return;
          }

          showEstimate(place.suburb, postcode, formatEta(first));
          saveLocation(
            root,
            postcode,
            place.suburb,
            place.province,
            window.MHDeliveryDate ? window.MHDeliveryDate.toYmd(first) : ''
          );
        })
        .catch(function () {
          showError(strings.checkError || "We couldn't check delivery for this postcode. Try again.");
        })
        .finally(function () {
          setChecking(false);
        });
    }

    checkBtn.addEventListener('click', function (event) {
      event.preventDefault();
      applyEstimate();
    });
    postcodeInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyEstimate();
      }
    });
    suburbSelect.addEventListener('change', function () {
      suburbSelect.classList.toggle('filled', Boolean(suburbSelect.value));
      hideEstimate();
      clearError();
    });
    postcodeInput.addEventListener('input', function () {
      clearTimeout(lookupTimer);
      lookupTimer = setTimeout(lookupPostcode, 250);
    });
    if (changeBtn) {
      changeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        showForm();
        if (postcodeInput && typeof postcodeInput.focus === 'function') {
          window.setTimeout(function () {
            postcodeInput.focus({ preventScroll: true });
          }, 850);
        }
      });
    }

    placeDelivery();

    window.addEventListener('resize', function () {
      placeDelivery();
    });

    var saved = savedLocation(root);
    if (saved && saved.postcode && saved.postcode.length === 4) {
      root.classList.add('is-summary');
      root.classList.remove('is-editing');
      if (form) form.setAttribute('aria-hidden', 'true');
      postcodeInput.value = saved.postcode;
      postcodeInput.classList.add('filled');
      fetchSuburbs(countryCode, saved.postcode).then(function (nextPlaces) {
        if (!nextPlaces.length && countryCode !== 'AU') {
          return fetchSuburbs('AU', saved.postcode);
        }
        return nextPlaces;
      }).then(function (nextPlaces) {
        if (!nextPlaces.length) {
          resetSuburb();
          showForm();
          return;
        }
        populateSuburbs(nextPlaces, saved.suburb);
        if (suburbSelect.value) {
          applyEstimate();
        } else {
          showForm();
        }
      }).catch(function () {
        resetSuburb();
        showForm();
      });
    } else {
      resetSuburb();
      showForm();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hamper-delivery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
